import { isNil } from "lodash";
import { useEffect, useState } from "react";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Box, Button } from "@mui/material";

interface MetronomeProps {
    bpm?: number
    title: string
}

const Metronome = (props: MetronomeProps) => {

    let [bpm] = useState<number>(isNil(props.bpm) ? 100 : props.bpm)
    let [playing, setPlaying] = useState<boolean>(false)
    let [blink, setBlink] = useState<boolean>(true)


    useEffect(() => {

        if(playing){
        let interval = setInterval(() => {
    
          setBlink(!blink);
    
        }, 60 / bpm * 1000);
    
        return () => clearInterval(interval);
        }
        else
        {
            setBlink(true)
        }
          // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [playing, blink]);

    return <Box display="flex">
        <FiberManualRecordIcon sx={{color: blink ? "white" : "red", fontSize: "30px"}}/>
        <FiberManualRecordIcon sx={{color: !blink ? "white" : "red", fontSize: "30px"}}/>
        <Button onClick={() => setPlaying(!playing)}>Launch {props.title}</Button>
    </Box>
}

export default Metronome;